import { render, staticRenderFns } from "./tableButtons.vue?vue&type=template&id=1b98a1b2&scoped=true&"
import script from "./tableButtons.vue?vue&type=script&lang=js&"
export * from "./tableButtons.vue?vue&type=script&lang=js&"
import style0 from "./tableButtons.vue?vue&type=style&index=0&id=1b98a1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98a1b2",
  null
  
)

export default component.exports